import { ModuleName } from "./module-name";

export function resolveModuleName(moduleName: string) {
  const m = toSlug(moduleName);
  if (!Object.values(ModuleName).includes(m as ModuleName)) {
    return {
      error: new Error("Invalid module name"),
      moduleName: null,
    };
  }
  return {
    error: null,
    moduleName: m as ModuleName,
  };
}
/**
 * Converts a string to a URL-friendly slug
 */
export function toSlug(str: string): string {
  return str
    .toLowerCase()
    .trim()
    .replaceAll(/[^\w\s-]/g, "") // Remove special characters
    .replaceAll(/[\s_-]+/g, "-") // Replace spaces, underscores, and multiple hyphens with single hyphen
    .replaceAll(/(^-+)|(-+$)/g, ""); // Remove leading/trailing hyphens
}
